// extracted by css-extract-rspack-plugin
export default {"downloadFileIcon":"DownloadFileIcon__downloadFileIcon--XvpVl"};